import React from 'react';
import { useTheme } from './ThemeProvider';

export function Button({
  variant = 'primary',
  children,
  onClick,
  disabled,
}: {
  variant?: 'primary' | 'secondary' | 'ghost';
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}) {
  const t = useTheme();
  const styles: React.CSSProperties = {
    padding: `${t.spacing.sm} ${t.spacing.lg}`,
    borderRadius: t.radius.md,
    border: variant === 'secondary' ? `1px solid ${t.color.primary}` : 'none',
    background:
      variant === 'primary'
        ? t.color.primary
        : variant === 'secondary'
        ? t.color.white
        : 'transparent',
    color: variant === 'primary' ? t.color.white : t.color.primary,
    fontFamily: t.font.family,
    fontSize: t.font.size.md,
    fontWeight: t.font.weight.medium,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    transition: 'opacity 0.15s, transform 0.1s',
  };
  return (
    <button style={styles} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}

export function Card({ children }: { children: React.ReactNode }) {
  const t = useTheme();
  return (
    <div
      style={{
        background: t.color.white,
        borderRadius: t.radius.lg,
        padding: t.spacing.lg,
        boxShadow: t.shadow.md,
        border: `1px solid ${t.color.grey100}`,
      }}
    >
      {children}
    </div>
  );
}

export function Screen({
  title,
  children,
}: {
  title?: string;
  children: React.ReactNode;
}) {
  const t = useTheme();
  return (
    <div
      style={{
        minHeight: '100vh',
        background: t.color.grey50,
        fontFamily: t.font.family,
        color: t.color.ink,
        padding: t.spacing.lg,
        paddingTop: `calc(${t.spacing.xl} + env(safe-area-inset-top))`,
      }}
    >
      {title && (
        <h1
          style={{
            fontSize: t.font.size.xl,
            fontWeight: t.font.weight.bold,
            margin: `0 0 ${t.spacing.lg} 0`,
            color: t.color.ink,
          }}
        >
          {title}
        </h1>
      )}
      {children}
    </div>
  );
}
